// GENERATED by scripts/apply-brand.mjs from brand/generic/brand.config.js.
// Do not edit — your changes will be overwritten on the next build.
export const coverImage = "";
